import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";
import imgLogo2 from "../assets/logo2.svg";
import NavbarButtons from "./NavbarButtons";
import useStore from "../store/store";

function Header() {
  const { user, isLoggedIn } = useStore((state) => state);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar>
        <Toolbar
          position="fixed"
          style={{ backgroundColor: "#fff" }}
          className="toolbar"
        >
          <Box edge="start">
            <img src={imgLogo2} alt="logo" style={{ height: 30 }} />
          </Box>
          {user && isLoggedIn && (
            <>
              <Box sx={{ flexGrow: 1 }}></Box>
              <Box sx={{ display: { xs: "none", md: "block" } }}>
                <NavbarButtons />
              </Box>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Header;
